// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportItem.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
! function () {
  var observer = require('mobx-react').observer;
  var React = require('react');

  var ReportDetail = require('./Izenda.ReportDetail');
  var constants = require('logic/data/Izenda.ReportsConstants');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var AffixContainer = require('share/components/controls/Izenda.AffixContainer');
  var classnames = require('classnames');

  var SearchCriteria = constants.SEARCH_CRITERIA;


  var ReportItem = React.createClass({
    propTypes: {
      store: React.PropTypes.object,
    },

    render: function () {
      var props = this.props;
      var store = props.store;
      var reportSubscriptionStore = props.reportSubscriptionStore;
      var reportSubCategory = props.reportSubCategory;
      var reportCategory = props.reportCategory;
      //var reports = reportSubCategory.reports;
      var cateName = getCateName();

      var report = props.report;

      var classes = classnames('panel panel-default izenda-ReportItem', {
        'izenda-ReportItem_last': props.isLastItem
      });
      var classesHeader = classnames('izenda-ReportItemHeader panel-heading text-uppercase sticky', {
        'u_block': props.isFirstItem,
        'u_none': props.isTrainingMode
      });

      return (
        <AffixContainer className={classes}
                        getAffix={this.getAffix}
                        affixClass="show-header">
          <div ref='affix'
               className={classesHeader}>
            { getHeaderName() }
          </div>
          <ReportDetail {...props}
                        className={props.isFirstItem ? 'u_noMarginTop': '' }
                        store={store}
                        pretext={cateName}
                        boardDetail={report}
                        reportSubCategory={reportSubCategory}
                        reportSubscriptionStore={reportSubscriptionStore} />

        </AffixContainer>
      );


      function getCateName() {
        var cateName = reportCategory.isUncategorized
          ? constants.UNCATEGORIZED
          : reportCategory.name;

        return cateName + (reportSubCategory.isUncategorized ? '' : '-' + reportSubCategory.name);
      }


      function getHeaderName() {
        if (reportCategory.isUncategorized) {
          return constants.UNCATEGORIZED;
        }

        if (reportSubCategory.isUncategorized) {
          return <TextHighLight highlight={store.items.searchText}
                                text={reportCategory.name}
                                className="text-bold"
                                notHighlight={isNotHighLight(store.items.searchType, SearchCriteria[7].value)} />
                            }

                            return (
          <span>
            <TextHighLight highlight={store.items.searchText}
                           text={reportCategory.name}
                           className="text-bold"
                           notHighlight={isNotHighLight(store.items.searchType, SearchCriteria[7].value)} />
            &nbsp;-&nbsp;
            <TextHighLight highlight={store.items.searchText}
                           text={reportSubCategory.name}
                           className="text-bold"
                           notHighlight={isNotHighLight(store.items.searchType, SearchCriteria[8].value)} />
          </span>
        )
      }


      function isNotHighLight(searchType, field) {
        return searchType === constants.SEARCH_CRITERIA[0].value
          ? false
          : searchType === field ? false : true
      }
    },

    getAffix: function () {
      return this.refs.affix;
    }
  });

  module.exports = observer(ReportItem);
}();



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportList/Izenda.ReportItem.jsx